// extracted by mini-css-extract-plugin
export default {"content":"styles_content__gSNcP","buttons":"styles_buttons__LQ1FM","button-wrapper":"styles_button-wrapper__fsxVj"};